import { lazy } from 'react';
import { paths } from '../../routes/paths';

// The admin sections, in sidebar order. This list drives BOTH the routes (routes/AppRoutes.js) and
// the sidebar (layouts/AdminLayout.js), so a URL and its menu entry can never drift apart.
// `soon` marks sections whose data doesn't exist yet (they need refunds and reporting):
// they get a "coming soon" page instead of a screen.
export const ADMIN_SECTIONS = [
  { key: 'organisers', label: 'Organisers', path: paths.admin.organisers, Component: lazy(() => import('./OrganisersAdmin')) },
  { key: 'users', label: 'Users', path: paths.admin.users, Component: lazy(() => import('./UsersAdmin')) },
  { key: 'events', label: 'Events', path: paths.admin.events, Component: lazy(() => import('./EventsAdmin')) },
  { key: 'categories', label: 'Categories', path: paths.admin.categories, Component: lazy(() => import('./CategoriesAdmin')) },
  { key: 'staff', label: 'Staff', path: paths.admin.staff, Component: lazy(() => import('./StaffAdmin')) },
  { key: 'orders', label: 'Orders', path: paths.admin.orders, Component: lazy(() => import('./OrdersAdmin')) },
  { key: 'refunds', label: 'Refunds', path: paths.admin.refunds, Component: lazy(() => import('./RefundsAdmin')) },
  { key: 'reports', label: 'Reports', path: paths.admin.reports, Component: lazy(() => import('./ReportsAdmin')) },
  { key: 'pages', label: 'Pages', path: paths.admin.pages, splat: true, Component: lazy(() => import('./PagesAdmin')) },
  { key: 'settings', label: 'Settings', path: paths.admin.settings, splat: true, Component: lazy(() => import('./SettingsAdmin')) },
  { key: 'audit-log', label: 'Audit log', path: paths.admin.auditLog, Component: lazy(() => import('./AuditAdmin')) },
];

export const MyProfile = lazy(() => import('./MyProfile'));
